import { CustomerFiles } from "@/pages/Dashboard/Customers/CustomerPage/components/CustomerFiles";
import { Divider } from "@heroui/react";
import { Trans } from "@lingui/react/macro";

export const AppointmentCustomerFiles = ({
  customerId,
  userAppointmentId,
}: {
  customerId?: number;
  userAppointmentId: number;
}) => {
  return (
    <div className="ml-1 mr-2">
      <Divider className="my-2" />

      <p className="text-sm font-medium">
        <Trans>Datoteke na terminu</Trans>
      </p>

      {customerId != null && (
        <CustomerFiles
          customerId={customerId}
          userAppointmentId={userAppointmentId}
          isOnAppointmentModal
        />
      )}
    </div>
  );
};
